import React from 'react';
import { Outlet } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { Header } from './Header';
import { Footer } from './Footer';
import { MobileCallBar } from './MobileCallBar';
import { ScrollManager } from './ScrollManager';
import { StructuredData } from './StructuredData';
export function Layout() {
  const {
    t
  } = useLanguage();
  return <div className="flex min-h-screen w-full flex-col bg-white pb-[76px] lg:pb-0" data-id="element-186" data-mp="353n2xdr7v0zf">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-lg focus:bg-brand focus:px-4 focus:py-3 focus:text-white" data-id="element-187" data-mp="3a2hlcel9unj0">
        {t({
        en: 'Skip to main content',
        es: 'Saltar al contenido principal'
      })}
      </a>
      <ScrollManager data-id="element-188" data-mp="3j0ti6ycqehjw" />
      <StructuredData data-id="element-189" data-mp="1ko1mm7gmoex8" />
      <Header data-id="element-190" data-mp="1kol63slxfbdd" />
      <main id="main" className="flex-1" data-id="element-191" data-mp="1kp4eoiposneq">
        <Outlet data-id="element-192" data-mp="1op4zqm7ajwur" />
      </main>
      <Footer data-id="element-193" data-mp="1ood9lqwgqrbv" />
      <MobileCallBar data-id="element-194" data-mp="1opwnxbyk6sb0" />
    </div>;
}